<template>
  <div class="activity-list">
    <transition-group name="fade" appear>
      <div class="activity-item" v-for="item in items" :key="`s${item.id}`">
        <div class="activity-image">
          <img :src="item.image"/>
        </div>
        <div class="activity-content">
          <h3>{{ item.message }}</h3>
          <div class="activity-hint" v-if="item.hint" v-html="item.hint"></div>
          <span>{{ formattedDate(item.date) }}</span>
        </div>
      </div>
    </transition-group>
    <div v-if="items.length < 4" class="empty-content" :style="computedStyle">
      <div class="header">
        Participates more - Get more
      </div>
      <p>Perform actions on the platform and get rewarded.</p>
    </div>
  </div>
</template>

<script>
	export default {
		name: "e-activity",
    props: {
      items: {
        type: Array,
        default: [],
      }
    },
    computed: {
      computedStyle() {
        return {
          height: (5 - this.items.length) * 66 + 'px',
          opacity: 0.5
        }
      }
    },
    methods: {
      formattedDate(date) {
        return this.$moment(date).fromNow();
      },
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/activity/activity.vue